import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';
import { useTranslation } from 'react-i18next';

ProjectItem.propTypes = {
    item: PropTypes.object,
};

function ProjectItem(props) {
    const { item } = props;

    const { i18n } = useTranslation();
    const lang = i18n.language && i18n.language.startsWith('ru') ? 'ru' : 'uz';

    const title = item.title?.[lang] ?? item.title?.uz ?? '';
    const category = item.category?.[lang] ?? item.category?.uz ?? '';
    const tech = (item.tech || []).slice(0, 2).join(' · ');

    const card = (
        <>
            <img className="project-card__shot" src={item.img} alt={title} width="1400" height="875" loading="lazy" />
            <div className="project-card__body">
                <div className="project-card__title">{title}</div>
                <div className="project-card__meta">{[category, tech].filter(Boolean).join(' — ')}</div>
            </div>
        </>
    );

    return item.url ? (
        <a className="project-card" href={item.url} target="_blank" rel="noreferrer">
            {card}
        </a>
    ) : (
        <div className="project-card">{card}</div>
    );
}

export default ProjectItem;
